import { THREE } from '@powerplay/common';
export const defaults = {
    fov: 70,
    near: 1,
    far: 23000,
    debugPositionStart: new THREE.Vector3(0, 10, 0),
    fovOffset: 20
};
//# sourceMappingURL=index.js.map